export default "__VITE_ASSET__64ca0777__"